import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from '@apollo/client';
import './index.css';
import WebFont from 'webfontloader';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import AuthVerificationProvider from './components/AuthVerificationProvider';

WebFont.load({
  google: {
    families: [
      'Poppins:400,500,600,700,800',
      'Roboto:400,500,300&display=swap',
    ],
  },
});
const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_API}/graphql`,
  credentials: 'include',
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <ThemeProvider theme={theme}>
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}
    >
      <ApolloProvider client={client}>
        <BrowserRouter>
          <AuthVerificationProvider>
            <App />
          </AuthVerificationProvider>
        </BrowserRouter>
      </ApolloProvider>
    </GoogleOAuthProvider>
  </ThemeProvider>,
);
